/* @flow */

import { CSSTransition, Transition, TransitionGroup } from 'react-transition-group';
import * as React from 'react';

import { Pizza } from './domain/pizza';
import PizzaCheese from './PizzaCheese';
import PizzaCrust from './PizzaCrust';
import PizzaSauce from './PizzaSauce';
import PizzaTopping from './PizzaTopping';

type Props = {
  pizza: Pizza,
  current: 'crust' | 'sauce' | 'cheese' | number,
  onAnimationEnd: Function,
};

export class AnimatedPizza extends React.Component<Props> {
  render() {
    const { pizza, current, onAnimationEnd } = this.props;

    const crust = (
      <CSSTransition key="crust" timeout={800} classNames="drop">
        <PizzaCrust crust={pizza.crust} />
      </CSSTransition>
    );

    let sauce = null;
    if (current !== 'crust') {
      sauce = (
        <CSSTransition key="sauce" timeout={800} classNames="proc-animatedPizza--sauce" onEntered={onAnimationEnd}>
          <PizzaSauce sauce={pizza.sauce} />
        </CSSTransition>
      );
    }

    let cheese = null;
    if (current !== 'crust' && current !== 'sauce') {
      cheese = (
        <CSSTransition key="cheese" timeout={800} classNames="proc-animatedPizza--sauce" onEntered={onAnimationEnd}>
          <PizzaCheese />
        </CSSTransition>
      );
    }

    let toppings = null;
    if (typeof current === 'number') {
      toppings = (
        <Transition timeout={0}>
          <TransitionGroup appear>
            {pizza.toppings.slice(0, current + 1).map((topping, index) => (
              <CSSTransition
                key={`topping-${index}`}
                timeout={800}
                classNames="proc-animatedPizza--topping"
                onEntered={onAnimationEnd}
              >
                <PizzaTopping topping={topping} />
              </CSSTransition>
            ))}
          </TransitionGroup>
        </Transition>
      );
    }

    return (
      <TransitionGroup className="proc-animatedPizza">
        {crust}
        {sauce}
        {cheese}
        {toppings}
      </TransitionGroup>
    );
  }
}
